import React from 'react';

export interface FilterOption {
  id: string;
  label: string;
}

interface CommentFiltersProps {
  options: FilterOption[];
  activeFilter: string;
  onFilterChange: (filterId: string) => void;
  className?: string;
  totalComments?: number;
}

const CommentFilters: React.FC<CommentFiltersProps> = ({
  options,
  activeFilter,
  onFilterChange,
  className = '',
  totalComments,
}) => {
  return (
    <div className={`bg-transparent p-4 mb-6 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Filter options */}
        <div className="flex flex-wrap gap-2">
          {options.map((option) => (
            <button
              key={option.id}
              onClick={() => {
                console.log("Filter button clicked:", option.id);
                onFilterChange(option.id);
              }}
              className={`
                px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
                ${activeFilter === option.id
                  ? 'bg-coral-pink text-white shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }
              `}
              aria-pressed={activeFilter === option.id}
            >
              {option.label}
            </button>
          ))}
        </div>
        
        {/* Comment count - only show if totalComments is provided */}
        {totalComments !== undefined && (
          <div className="flex items-center">
            <div className="text-sm text-gray-600">
              {totalComments} {totalComments === 1 ? 'comment' : 'comments'}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentFilters;